module.exports = __webpack_public_path__ + "img/Prize_btn.7e023846.png";